const INDEX_ITEMS = [
  { id: 1, name: '明星八卦一线', desc: '最新明星动态与独家内幕', tag: '热门', icon: 'ri-star-line' },
  { id: 2, name: '网红爆料专区', desc: '头部网红争议事件全追踪', tag: '推荐', icon: 'ri-user-smile-line' },
  { id: 3, name: '综艺节目剧透', desc: '录制现场花絮与淘汰内幕', tag: '新站', icon: 'ri-tv-line' },
  { id: 4, name: '影视圈深扒', desc: '剧组秘闻与行业潜规则', tag: '热门', icon: 'ri-film-line' },
  { id: 5, name: '音乐圈大事件', desc: '歌手动态与版权纷争', tag: '', icon: 'ri-music-line' },
  { id: 6, name: '体育圈吃瓜', desc: '运动员场外生活全记录', tag: '', icon: 'ri-basketball-line' },
  { id: 7, name: '电竞圈爆料', desc: '职业选手转会与战队内幕', tag: '新站', icon: 'ri-gamepad-line' },
  { id: 8, name: '社会热点追踪', desc: '全网热门事件深度追踪', tag: '推荐', icon: 'ri-fire-line' },
  { id: 9, name: '海外吃瓜站', desc: '日韩欧美娱乐圈一手资讯', tag: '', icon: 'ri-global-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-3">
            导航索引
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            吃瓜爆料网站导航
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-xl mx-auto">
            按主题分类浏览，快速定位你感兴趣的吃瓜爆料网站
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {INDEX_ITEMS.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group flex items-center gap-4 p-4 md:p-5 bg-background-100 rounded-xl border border-background-200/60 hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <div className="w-11 h-11 rounded-xl bg-background-50 border border-background-200/60 flex items-center justify-center shrink-0 group-hover:border-primary-200 group-hover:bg-primary-50 transition-colors">
                <i className={`${item.icon} text-lg text-foreground-600 group-hover:text-primary-600 transition-colors`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
                    {item.name}
                  </h3>
                  {item.tag && (
                    <span className={`shrink-0 px-1.5 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                      item.tag === '热门' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '推荐' ? 'bg-accent-100 text-accent-700' :
                      'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                  )}
                </div>
                <p className="text-xs text-foreground-500 truncate">{item.desc}</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}